module.exports = __webpack_public_path__ + "img/yzgQRCode.ebf74cf9.png";